import { logger } from '~/features/logging/logger';

import { getEnrollment } from '../controllers/get-enrollment';
import { getEnrollmentProgressRaw } from '../controllers/get-enrollment-progress-raw';
import { EnrollmentProgressRaw } from '../models/enrollment-progress';
import { Enrollment } from '../models/program-enrollment';

const MAX_RETRIES = 10;

export async function pollForEnrollment({
  programKey,
  retryCount = 0,
}: {
  programKey: string;
  retryCount?: number;
}): Promise<{ enrollment: Enrollment; enrollmentProgress: EnrollmentProgressRaw } | null> {
  try {
    const [enrollment, enrollmentProgress] = await Promise.all([
      getEnrollment({ programKey }),
      getEnrollmentProgressRaw(programKey),
    ]);

    if (enrollment && enrollmentProgress.data) {
      return { enrollment, enrollmentProgress };
    }
  } catch (error) {
    logger.error('Error polling for enrollment', error);
  }

  if (retryCount < MAX_RETRIES) {
    await new Promise((resolve) => setTimeout(resolve, 2000));
    return await pollForEnrollment({ programKey, retryCount: retryCount + 1 });
  } else {
    return null;
  }
}
